(function () {
    'use strict';

    angular.module("imApp").factory("colorGrpService", ['$ihttp', function ($ihttp) {
        let service = {
            getEdit: function (parms) {
                return $ihttp.post({
                    method: 1208,
                    parameters: parms || {}
                });
            },
            saveObj: function (edit) {
                return $ihttp.post({
                    method: 1209,
                    parameters: edit
                });
            }
        };

        return service;
    }]);
})();
